/**
 * @fileoverview GET handler for the "/:app_group_id/conversational/tool_definition/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalToolDefinitionId } from "./constants";
import type { ConversationalToolDefinitionIdResult, GetConversationalToolDefinitionIdProps } from "./types";
import { isConversationalToolDefinitionIdResult } from "./validators";

export const getConversationalToolDefinitionId = reactQueryFetcherAdapter(
  conversationalToolDefinitionId,
  (
    signal: AbortSignal,
    { appGroupId, definitionId, type }: GetConversationalToolDefinitionIdProps
  ): Promise<ConversationalToolDefinitionIdResult> => {
    return fetch(`/${appGroupId}/conversational/tool_definition/${definitionId}`, "GET", { type }, { signal });
  },
  isConversationalToolDefinitionIdResult
);
